/* eslint-disable */
import moment from 'moment';
import 'moment-precise-range-plugin';

export const dateDifferece = (fromdate, todate) => {
    var date1 = moment(fromdate);
    var date2 = moment(todate);

    if (date1 == date2) {
        date2 = moment(todate);

    }
    else {
        date2 = moment(todate).add(1, 'days');
    }

    var difference = moment.preciseDiff(date1, date2, true);
    return difference
};

export const dateDiffereceExServiceMan = (fromdate, todate) => {
    var date1 = moment(fromdate);
    var date2 = moment(todate).add(1, 'days');
    var difference = moment.preciseDiff(date1, date2, true);
    return difference
};

// export const toUTCDate = (date) => {
//     console.log(date)
//     return date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) : date;
// };


export const fromUTCDate = (date) => {
    const finalDate = date ? new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) : date;
    return finalDate
};

export const formatDateForSubmit = (date) => {
    if (!date) return null;
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return utcDate.toISOString().replace("Z", "+00:00");
};
export const dateDifference = (fromDate, toDate) => {
    const date1 = moment(fromDate);
    const date2 = moment(toDate);
    const adjustedDate2 = date1.isSame(date2, "day") ? moment(toDate) : moment(toDate).add(1, "days");
    const difference = moment.preciseDiff(date1, adjustedDate2, true);
    return {
        years: difference.years,
        months: difference.months,
        days: difference.days,
    };
};

// export const getFormattedDate = (date) => {
//     if (!date) return null;
//     // Ensure 'date' is a Date object
//     const parsedDate = new Date(date);

//     if (isNaN(parsedDate.getTime())) {
//         console.error("Invalid date format:", date);
//         return null;
//     }
//     // Convert to UTC while preserving the correct date
//     return new Date(Date.UTC(
//         parsedDate.getFullYear(),
//         parsedDate.getMonth(),
//         parsedDate.getDate()
//     ));
// };

export const getFormattedDate = (inputDateStr) => {
    if (!inputDateStr) return null;
    try {
        const inputDate = new Date(inputDateStr);
        if (isNaN(inputDate.getTime())) {
            console.error("Invalid date:", inputDateStr);
            return null;
        }

        // Extract year, month, day in IST
        const options = {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        };

        const formatter = new Intl.DateTimeFormat("en-GB", options);
        const parts = formatter.formatToParts(inputDate);

        const getPart = (type) => parts.find(p => p.type === type)?.value || "00";

        const year = parseInt(getPart("year"));
        const month = parseInt(getPart("month")) - 1; // JS months: 0-based
        const day = parseInt(getPart("day"));

        // Create date with 00:00:00 time (in system's local, representing IST date)
        return new Date(year, month, day);





    } catch (error) {
        console.error("Error converting to IST date:", error);
        return null;
    }
};




//  export const fromUTCDate = (date) => {
//     if (!date) return null;
//     // Ensure 'date' is a Date object
//     const parsedDate = new Date(date);

//     if (isNaN(parsedDate.getTime())) {
//         console.error("Invalid date format:", date);
//         return null;
//     }
//     // Convert to UTC while preserving the correct date
//     return new Date(Date.UTC(
//         parsedDate.getFullYear(),
//         parsedDate.getMonth(),
//         parsedDate.getDate()
//     ));
// };


export const preventDateManualTyping = (e) => {
    e.preventDefault();
};

export const toUTCDate = (date) => {
    if (!date) return null;

    // Set time to noon UTC to avoid timezone offset issues
    const normalizedDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        12, 0, 0 // Set to 12:00 PM UTC
    ));
    return normalizedDate;
};


export const formatToDDMMYYYY = (input) => {
    if (!input) return null;

    try {
        const date = new Date(input);
        if (isNaN(date.getTime())) return null;

        const pad = (n) => n.toString().padStart(2, '0');

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    } catch (e) {
        console.error("Invalid date format:", e);
        return null;
    }
};
export const formatToDDMMYYYY_HHMMSS = (input) => {
    if (!input) return null;

    try {
        const date = new Date(input);
        if (isNaN(date.getTime())) return null;

        const pad = (n) => n.toString().padStart(2, '0');

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1); // Months are 0-indexed
        const year = date.getFullYear();

        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${day}/${month}/${year} , ${hours}:${minutes}:${seconds}`;
    } catch (e) {
        console.error("Invalid date format:", e);
        return null;
    }
};
